module.exports = __webpack_public_path__ + "static/media/fly0086.30ef64a4.webp";